import {Component, React, observer} from '$src/handy'
import * as css from './FreezeStateButton.css'
import GenericButton from '$src/common/GenericButton'
import CircleIcon from 'react-icons/lib/fa/circle'
import {HousingCorporation} from '$src/bootstrap/Store'
import editHousingCorporationReadyState from '$src/api/endpoints/housingCorporations/editHousingCorporationReadyState'
import GenericModal from '$src/common/GenericModal'
import {createRef} from 'react'

interface Props {
  css?: any
  housingCorporation: typeof HousingCorporation.Type
}

interface State {
  submitting: boolean
  optimisticState: null | boolean
  promptIsShowing: boolean
}

@observer
export default class FreezeStateButton extends Component<Props, State> {
  modalRef = createRef()
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      submitting: false,
      optimisticState: null,
      promptIsShowing: false,
    }
  }

  render() {
    const {props} = this
    const {housingCorporation: housingCorporation} = props
    const frozen = housingCorporation.isFrozen()

    return (
      <GenericButton
        variant="round"
        withMargin
        css={{container: css.button}}
        onClick={this.showAreYouSurePrompt}
        disabled={this.state.submitting}
      >
        {frozen ? 'Frozen' : 'Valuation ongoing'}
        <CircleIcon
          color={frozen ? 'rgb(26, 209, 255)' : '#20bd02'}
          style={{marginLeft: '6px'}}
        />
        {this.state.promptIsShowing && (
          <GenericModal
            // show={this.state.promptIsShowing}
            onHide={this.hideAreYouSurePrompt}
            withPadding={true}
            css={{box: {container: css.areYouSureBox}}}
          >
            <p className={css.warningMessage}>
              {frozen ? 'Continue valuation?' : 'Freeze research?'}
            </p>
            <GenericButton
              variant="pale"
              type="submit"
              onClick={(e: React.SyntheticEvent) => {
                e.preventDefault()
                e.stopPropagation()
                this.hideAreYouSurePrompt()
              }}
              withMargin={true}
            >
              Never mind
            </GenericButton>
            <GenericButton
              variant="bold"
              type="submit"
              onClick={(e: React.SyntheticEvent) => {
                e.preventDefault()
                e.stopPropagation()
                this.toggle()
              }}
              withMargin={true}
            >
              {frozen ? 'Continue valuation' : 'Freeze and save results'}
            </GenericButton>
          </GenericModal>
        )}
      </GenericButton>
    )
  }

  toggle = async () => {
    if (this.state.submitting) return
    const frozen = !this.props.housingCorporation.isFrozen()
    this.setState({submitting: true, optimisticState: frozen})
    try {
      await this.callEndpoint(editHousingCorporationReadyState, {
        cid: this.props.housingCorporation._id,
        ready: frozen,
      })
    } catch (e) {
      this.setState({
        submitting: false,
        optimisticState: null,
        promptIsShowing: false,
      })
      console.log('Error editing Freeze state state:')
      console.error(e)
      return
    }

    this.setState({
      submitting: false,
      optimisticState: null,
      promptIsShowing: false,
    })
    if (frozen) {
      this.props.housingCorporation.freeze()
    } else {
      this.props.housingCorporation.thaw()
    }
  }

  showAreYouSurePrompt = () => {
    this.setState({promptIsShowing: true})
  }

  hideAreYouSurePrompt = () => {
    this.setState(() => ({promptIsShowing: false}))
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/FreezeStateButton.tsx